// Globals
import { useTranslation } from 'react-i18next';

// Models
import { IOrderDetails, ISubOrder } from '@/models/orders.model';

// Components
import {
  StyledWrapper,
  StyledContentItemsWrapper,
  StyledContentBlock,
  StyledLabelWrapper,
  StyledLabel,
  StyledTooltipIcon,
  StyledValue,
  StyledTooltipText,
  StyledProportionsValue,
} from './SummaryWeightAndPriceStyles';
import { Tooltip } from '@/ui';
import { COLORS } from '@/theme';

interface SummaryWeightAndPriceProps {
  isSummaryInfo?: boolean;
  data?: ISubOrder | IOrderDetails;
}

const SummaryWeightAndPrice = ({ data, isSummaryInfo }: SummaryWeightAndPriceProps) => {
  const { t } = useTranslation(['orders']);

  return (
    <StyledWrapper $isSummaryInfo={!!isSummaryInfo}>
      <StyledContentItemsWrapper $isRight={true}>
        {isSummaryInfo && (
          <StyledContentBlock>
            <StyledLabel>{t('order_details_summary_delivery_price')}</StyledLabel>
            <StyledValue>{data?.delivery_price} ₴</StyledValue>
          </StyledContentBlock>
        )}
        <StyledContentBlock>
          <StyledLabel>{t('order_details_summary_total_price')}</StyledLabel>
          <StyledValue>{data?.total_price} ₴</StyledValue>
        </StyledContentBlock>
      </StyledContentItemsWrapper>
      <StyledContentItemsWrapper>
        <StyledContentBlock>
          <StyledLabel>{t('order_details_summary_weight')}</StyledLabel>
          <StyledValue>{`${data?.total_weight} ${t('order_weight_kg')}`}</StyledValue>
        </StyledContentBlock>
        <StyledContentBlock>
          <StyledLabelWrapper>
            <StyledLabel>{t('order_details_summary_proportions')}</StyledLabel>
            <Tooltip
              title={<StyledTooltipText>{t('order_details_summary_proportions_tooltip')}</StyledTooltipText>}
              color={COLORS.IRON_GRAY}
              placement="topRight"
            >
              <StyledTooltipIcon />
            </Tooltip>
          </StyledLabelWrapper>
          <StyledProportionsValue>{data?.proportions}</StyledProportionsValue>
        </StyledContentBlock>
        <StyledContentBlock>
          <StyledLabel>{t('order_details_summary_volume_weight')}</StyledLabel>
          <StyledValue>{`${data?.volume_weight} ${t('order_weight_kg')}`}</StyledValue>
        </StyledContentBlock>
      </StyledContentItemsWrapper>
    </StyledWrapper>
  );
};

export default SummaryWeightAndPrice;
